import {
  put, takeLatest, all, takeEvery,
} from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import UnicommerceIntegrationActions, { unicommerceIntegrationActionTypes } from '../../actions/integrations/unicommerceIntegrationActions';
import UnicommerceIntegrationServices from '../../services/integrations/unicommerceIntegrationServices';

/**
 * @param action
 */
function* _getUnicommerceConnections(action) {
  try {
    const {
      orgId, callback,
    } = action;
    yield put(UnicommerceIntegrationActions.getUnicommerceConnectionsLoading(true));
    const linkedUnicommerceAccounts = yield UnicommerceIntegrationServices.getUnicommerceConnections(orgId);
    yield put(UnicommerceIntegrationActions.getUnicommerceConnectionsSuccess(linkedUnicommerceAccounts));
    if (linkedUnicommerceAccounts.success) {
      if (callback) {
        callback(linkedUnicommerceAccounts);
      }
    }
    yield put(UnicommerceIntegrationActions.getUnicommerceConnectionsLoading(false));
  } catch (error) {
    yield put(UnicommerceIntegrationActions.getUnicommerceConnectionsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(unicommerceIntegrationActionTypes.GET_UNICOMMERCE_CONNECTIONS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getUnicommerceConnections() {
  yield takeLatest(unicommerceIntegrationActionTypes.GET_UNICOMMERCE_CONNECTIONS.REQUEST, _getUnicommerceConnections);
}

/**
 * @param action
 */
function* _connectToUnicommerce(action) {
  try {
    const { payload, callback } = action;
    yield put(UnicommerceIntegrationActions.connectToUnicommerceLoading(true));
    const connectToUnicommerceData = yield UnicommerceIntegrationServices.connectToUnicommerce(payload);
    yield put(UnicommerceIntegrationActions.connectToUnicommerceSuccess(connectToUnicommerceData));
    if (connectToUnicommerceData.success) {
      notification.open({
        type: 'success',
        message: 'Connected Successful',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: connectToUnicommerceData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(UnicommerceIntegrationActions.connectToUnicommerceLoading(false));
  } catch (error) {
    yield put(UnicommerceIntegrationActions.connectToUnicommerceLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(unicommerceIntegrationActionTypes.CONNECT_TO_UNICOMMERCE.ERROR, error));
  }
}
/**
 *
 */
function* connectToUnicommerce() {
  yield takeEvery(unicommerceIntegrationActionTypes.CONNECT_TO_UNICOMMERCE.REQUEST, _connectToUnicommerce);
}

/**
 * @param action
 */
function* _connectTenantToLocation(action) {
  try {
    const { payload, callback } = action;
    yield put(UnicommerceIntegrationActions.connectTenantToLocationLoading(true));
    const connectToUnicommerceData = yield UnicommerceIntegrationServices.connectTenantToLocation(payload);
    if (connectToUnicommerceData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Connected Successful',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: connectToUnicommerceData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(UnicommerceIntegrationActions.connectTenantToLocationLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(UnicommerceIntegrationActions.connectTenantToLocationLoading(false));
    yield put(TrackerActions.trackAction(unicommerceIntegrationActionTypes.CONNECT_TENANT_TO_LOCATION_UNICOMMERCE.ERROR, error));
  }
}
/**
 *
 */
function* connectTenantToLocation() {
  yield takeLatest(unicommerceIntegrationActionTypes.CONNECT_TENANT_TO_LOCATION_UNICOMMERCE.REQUEST, _connectTenantToLocation);
}

/**
 * @param action
 */
function* _verifyLocation(action) {
  try {
    const { orgId, facilityCode, callback } = action;
    yield put(UnicommerceIntegrationActions.verifyLocationLoading(true));
    const connectToUnicommerceData = yield UnicommerceIntegrationServices.verifyLocation(orgId, facilityCode);
    if (connectToUnicommerceData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Verified Successful',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: connectToUnicommerceData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(UnicommerceIntegrationActions.verifyLocationLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(UnicommerceIntegrationActions.verifyLocationLoading(false));
    yield put(TrackerActions.trackAction(unicommerceIntegrationActionTypes.VERIFY_LOCATION.ERROR, error));
  }
}
/**
 *
 */
function* verifyLocation() {
  yield takeLatest(unicommerceIntegrationActionTypes.VERIFY_LOCATION.REQUEST, _verifyLocation);
}

/**
 * @param action
 */
function* _syncProducts(action) {
  try {
    const { payload, callback } = action;
    yield put(UnicommerceIntegrationActions.syncProductsLoading(true));
    const connectToUnicommerceData = yield UnicommerceIntegrationServices.syncProducts(payload);
    if (connectToUnicommerceData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Synced products.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: connectToUnicommerceData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(UnicommerceIntegrationActions.syncProductsLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(UnicommerceIntegrationActions.syncProductsLoading(false));
    yield put(TrackerActions.trackAction(unicommerceIntegrationActionTypes.SYNC_PRODUCT.ERROR, error));
  }
}
/**
 *
 */
function* syncProducts() {
  yield takeLatest(unicommerceIntegrationActionTypes.SYNC_PRODUCT.REQUEST, _syncProducts);
}

/**
 * @param action
 */
function* _syncSO(action) {
  try {
    const { payload, callback } = action;
    yield put(UnicommerceIntegrationActions.syncSOLoading(true));
    const connectToUnicommerceData = yield UnicommerceIntegrationServices.syncSO(payload);
    if (connectToUnicommerceData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Synced products.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: connectToUnicommerceData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(UnicommerceIntegrationActions.syncSOLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(UnicommerceIntegrationActions.syncSOLoading(false));
    yield put(TrackerActions.trackAction(unicommerceIntegrationActionTypes.SYNC_SO.ERROR, error));
  }
}
/**
 *
 */
function* syncSO() {
  yield takeLatest(unicommerceIntegrationActionTypes.SYNC_SO.REQUEST, _syncSO);
}

/**
 * @param action
 */
function* _adjustUnicommerceInventory(action) {
  try {
    const { payload, callback } = action;
    yield put(UnicommerceIntegrationActions.adjustUnicommerceInventoryLoading(true));
    const adjustUnicommerceInventoryData = yield UnicommerceIntegrationServices.adjustUnicommerceInventory(payload);
    if (adjustUnicommerceInventoryData.success) {
      notification.open({
        type: 'success',
        message: 'Inventory adjusted Successfully',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: adjustUnicommerceInventoryData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(UnicommerceIntegrationActions.adjustUnicommerceInventoryLoading(false));
  } catch (error) {
    yield put(UnicommerceIntegrationActions.adjustUnicommerceInventoryLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(unicommerceIntegrationActionTypes.ADJUST_UNICOMMERECE_INVENTORY.ERROR, error));
  }
}
/**
 *
 */
function* adjustUnicommerceInventory() {
  yield takeEvery(unicommerceIntegrationActionTypes.ADJUST_UNICOMMERECE_INVENTORY.REQUEST, _adjustUnicommerceInventory);
}

/**
 * @param action
 */
function* _updateUnicommerceConfiguration(action) {
  try {
    const { payload, callback } = action;
    yield put(UnicommerceIntegrationActions.updateUnicommerceConfigurationLoading(true));
    const updateUnicommerceConfigurationData = yield UnicommerceIntegrationServices.updateUnicommerceConfiguration(payload);
    if (updateUnicommerceConfigurationData.success) {
      notification.open({
        type: 'success',
        message: 'Configuration Updated Successfully',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: updateUnicommerceConfigurationData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(UnicommerceIntegrationActions.updateUnicommerceConfigurationLoading(false));
  } catch (error) {
    yield put(UnicommerceIntegrationActions.updateUnicommerceConfigurationLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(unicommerceIntegrationActionTypes.UPDATE_UNICOMMERCE_CONFIGURATION.ERROR, error));
  }
}
/**
 *
 */
function* updateUnicommerceConfiguration() {
  yield takeEvery(unicommerceIntegrationActionTypes.UPDATE_UNICOMMERCE_CONFIGURATION.REQUEST, _updateUnicommerceConfiguration);
}

function* _deleteUcSync(action) {
  try {
    const { payload, callback } = action;
    yield put(UnicommerceIntegrationActions.deleteUcSyncLoading(true));
    const scheduledJob = yield UnicommerceIntegrationServices.deleteUcJob(payload);
    if (scheduledJob.success) {
      notification.open({
        type: 'success',
        message: 'Stock sync job removed successfully',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: scheduledJob.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(UnicommerceIntegrationActions.deleteUcSyncLoading(false));
  } catch (error) {
    yield put(UnicommerceIntegrationActions.deleteUcSyncLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}


function* deleteUcSync() {
  yield takeEvery(unicommerceIntegrationActionTypes.DELETE_UNICOMMERCE_SYNC.REQUEST, _deleteUcSync);
}

function* _scheduleUcSync(action) {
  try {
    const { payload, callback } = action;
    yield put(UnicommerceIntegrationActions.scheduleUcSyncLoading(true));
    const scheduledJob = yield UnicommerceIntegrationServices.scheduleUcSync(payload);
    if (scheduledJob.success) {
      notification.open({
        type: 'success',
        message: 'Stock sync job added successfully',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: scheduledJob.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(UnicommerceIntegrationActions.scheduleUcSyncLoading(false));
  } catch (error) {
    yield put(UnicommerceIntegrationActions.scheduleUcSyncLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* scheduleUcSync() {
  yield takeEvery(unicommerceIntegrationActionTypes.SCHEDULE_UNICOMMERCE_SYNC.REQUEST, _scheduleUcSync);
}

/**
 *
 */
export default function* unicommerceIntegrationSaga() {
  yield all([
    getUnicommerceConnections(),
    connectToUnicommerce(),
    connectTenantToLocation(),
    verifyLocation(),
    syncProducts(),
    syncSO(),
    adjustUnicommerceInventory(),
    updateUnicommerceConfiguration(),
    scheduleUcSync(),
    deleteUcSync(),
  ]);
}
